export const checkErrorCode = (error: any, expectedCode: string) =>
  error?.response?.data?.error_code === expectedCode
